import {
	ERROR_MSG_INVALID_COUPON,
	ERROR_MSG_EXPIRED_COUPON,
	ERROR_MSG_MAX_REDEMPTIONS_COUPON,
	ERROR_MSG_REQUIRES_EMAIL_COUPON,
} from 'mytours-read-common'

import strings from 'mobile_web/strings'

// Maps a bundle redemption error (carrying one of the ERROR_MSG_* sentinels) to a localized
// message. Shared by the bundle redeem dialog and the URL/scan redemption page so the two can't
// drift (mirrors native's bundleErrorMessage()).
export const getBundleErrorMessage = (error?: Error): string | undefined => {
	if (!error) {
		return undefined
	}
	switch (error.message) {
		case ERROR_MSG_INVALID_COUPON:
			return strings.code_invalid
		case ERROR_MSG_EXPIRED_COUPON:
			return strings.code_expired
		case ERROR_MSG_MAX_REDEMPTIONS_COUPON:
			return strings.code_max_redemptions
		case ERROR_MSG_REQUIRES_EMAIL_COUPON:
			return strings.code_requires_email
		default:
			return strings.code_redemption_error
	}
}
